import React from 'react';
import classes from './style.module.css'
import { HORSE_TABLE_ALL_STATIC, HORSE_TABLE_COLUMNS_STATIC } from '../../../constants/Constants'
import OddResultCell from './OddResultCell'
import WinDetailCell from './WinDetailCell'
import StarRatings from 'react-star-ratings';
import bookIcon from "../../../assets/images/green-up-arrow.png"

const getRating = (lastRunStatusList, index) => {
    if (lastRunStatusList && lastRunStatusList.length > index) {
        const rating = lastRunStatusList[index].rating
        return Math.floor(rating * 100) / 100;
    }
    return "-";

}

const roundOff = (reating) => {
    return Math.floor(reating * 100) / 100;
}

const shortName = (name, size) => {
    return name ? name.substring(0, size) : '-';
}
const League = (props) => {
    const rowIndex = props.index + 1;
    const id = props.item.time;
    const type = props.type;
    const columnList = props.finalColumns;

    const cells = columnList.map(column => {
        let cell = null;
        const cellKey = id + "_" + column.id
        //console.log(props.item.raceId)
        switch (column.id) {
            case HORSE_TABLE_COLUMNS_STATIC.ROW_NUM.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.index}</th>
                break;
            case HORSE_TABLE_ALL_STATIC.TRACK.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.trackName}
                    {type === 'ALL' ? ' R' + props.item.raceId : ''}
                </th>
                break;
            case HORSE_TABLE_ALL_STATIC.TIME.id:
                cell = <th key={cellKey} className={classes.LeagueTdTh} scope="row">{props.item.raceTime}</th>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.BOX.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>
                    {props.item.raceType === 'HORSE' ? props.item.box : props.item.index}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.HORSE_NAME.id:
                cell = <td style={{ width: "50px" }} key={cellKey} className={classes.LeagueTdTh}>
                    {type === 'ALL' ? shortName(props.item.runner, 15) : props.item.runner}
                    {props.item.improvingHorse ? <img style={{ width: "9px", height: "9px", marginLeft: "1px" }} src={bookIcon} />
                        : ""}

                </td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.STAR_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}><StarRatings
                    starDimension="10px"
                    starSpacing="0"
                    rating={props.item.overallRating}
                    starRatedColor="blue"
                    numberOfStars={4}
                    name='rating'
                /></td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.JOCKEY.id:
                cell = <td key={cellKey} style={{ width: "50px" }} className={classes.LeagueTdTh}
                >
                    {type === 'ALL' ? shortName(props.item.jockey, 10) : props.item.jockey}
                </td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.TRAINER.id:
                cell = <td key={cellKey} style={{ width: "50px" }} className={classes.LeagueTdTh}>
                    {type === 'ALL' ? shortName(props.item.trainer, 10) : props.item.trainer}

                </td>
                break;
            /*case HORSE_TABLE_COLUMNS_STATIC.FIFTYD_RATING.id:
                cell = <td key={cellKey} style={{ width: "50px" }} className={classes.LeagueTdTh}>
                    {props.item.fiftyD}
                </td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.TWELVE_MONTHS_RATING.id:
                cell = <td key={cellKey} style={{ width: "50px" }} className={classes.LeagueTdTh}>
                    {props.item.twelveMonth}
                </td>
                break;
           
            case HORSE_TABLE_COLUMNS_STATIC.FIFTYD_RANK.id:
                cell = <td key={cellKey} style={{ width: "50px" }} className={classes.LeagueTdTh}>
                    {props.item.fiftyDRank}
                </td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.TWELVE_MONTHS_RANK.id:
                cell = <td key={cellKey} style={{ width: "50px" }} className={classes.LeagueTdTh}>
                    {props.item.twelveMonthRank}
                </td>
                break;*/

            case HORSE_TABLE_COLUMNS_STATIC.FORM.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.last5Run}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.WIN_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.winPercent}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.PLACE_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.placePercent}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.DAYS_SINCE_LAST_RUN.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{props.item.daysSinceLastRun}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.JOCKEY_TRAINER_WIN_PERCENT.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.totalJockeyTrainerWinPercent)}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.WIN_PRIZE_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.winPrizeRating)}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.FORM_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.formRatingPercent)}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.SKY_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.skyRating)}</td>
                break;

            case HORSE_TABLE_COLUMNS_STATIC.FPP_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.fppRating)}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.APR_RATING.id:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{roundOff(props.item.aprRating)}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.ODD_DETAILS.id:
                let part = props.item;
                console.log(JSON.stringify(part))
                let details = "-,-"
                if (part.bfSelectionId && part.bfMarketId) {
                    details = <OddResultCell type={type} date={props.date} oddChangeCallback={props.oddChangeCallback} marketId={part.bfMarketId} selectionId={part.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{details}</td>
                break;
            case HORSE_TABLE_COLUMNS_STATIC.WIN_DETAILS.id:
                let currentItem = props.item;
                let winnerDetails = "-"
                if (currentItem.bfSelectionId && currentItem.bfMarketId) {
                    winnerDetails = <WinDetailCell type={type} marketId={currentItem.bfMarketId}
                        date={props.date} time={props.item.raceTime}
                        selectionId={currentItem.bfSelectionId} />
                }
                cell = <td key={cellKey} className={classes.LeagueTdTh}>{winnerDetails}</td>
                break;
            default:
                cell = <td key={cellKey} className={classes.LeagueTdTh}>-</td>
        }
        return cell;
    })

    return (
        <tr className={classes.League}>
            {cells}
        </tr>
    )
}

export default League;